import MetaModel from "../../../Global/Models/Pagination/MetaModel";
import PrivateLeagueBasicModel from "./PrivateLeagueModel";

export default class PrivateLeaguesModel {
  public meta: MetaModel = new MetaModel();
  public data: PrivateLeagueBasicModel[] = [];
}
